export const license = [
  { name: 'Giấy phép không cụ thể', value: 'unspecified-license' },
  { name: 'Bản quyền được bảo hộ', value: 'reserved' },
  { name: 'Tên miền công khai', value: 'domain' },
];

export const FILE_TOO_LARGE = 'FILE_TOO_LARGE';
